import buildOnContextMenuCallback from "Areas/Documents/content/switcherFeed/utils/contextMenu/buildOnContextMenuCallback";
import { DOCUMENT_CONTENT_TYPE } from "Common/dictionaries/documentContentType";
import fileTypeToIconMap from "Common/fileUtils/fileIcon";
import fileType from "Common/fileUtils/fileType";
import Button from "Components/button";
import MediaPlayer from "Components/mediaPlayer";
import Menu from "Components/menu";
import ProgressOverlay from "Components/progressOverlay";
import Scrollbars from "Components/scrollbars";
import themeVariables from "Components/theme/themeVariables";
import WelcomePanel from "Components/welcomePanel";
import YesNoConfirmation from "Components/yesNoConfirmation";
import classNames from "classnames";
import keys from "lodash/keys";
import map from "lodash/map";
import reject from "lodash/reject";
import React, { useCallback, useMemo, useRef } from "react";
import locale from "./folder.locale";
import UploadArea from "./uploadArea";
const folderStyle = { minHeight: "300px" };
const folderHeaderStyle = { padding: "10px 8px 10px 12px", height: "40px" };
const thumbStyle = { width: "17px", height: "17px" };
const btnHolderStyle = { width: "90px" };
const fileNameStyle = { width: `calc(100% - ${btnHolderStyle.width} - ${thumbStyle.width})` };
const outerGridStyle = { gridTemplateColumns: "70% auto" };
const innerGridStyle = { gridTemplateRows: "4em 600px" };
const previewImageStyle = { objectPosition: "top" };
const bottomPad = "15em";
const documentContentTypeToComponent = {
    [DOCUMENT_CONTENT_TYPE.TEXT]: ({ value, className, style }) => (React.createElement("div", { className: className, style: style }, value)),
    [DOCUMENT_CONTENT_TYPE.IMAGE]: ({ value, className, style }) => (React.createElement("img", { className: className, src: value, style: style })),
    [DOCUMENT_CONTENT_TYPE.AUDIO]: ({ value, className, style }) => (React.createElement("div", { className: className, style: style },
        React.createElement(MediaPlayer, { type: "audio", source: value }))),
    [DOCUMENT_CONTENT_TYPE.VIDEO]: ({ value, className, style }) => (React.createElement("div", { className: className, style: style },
        React.createElement(MediaPlayer, { type: "video", source: value })))
};
export default function Folder(props) {
    const contextMenuRef = useRef(null);
    const imageComponentRef = useRef(null);
    const folderBlockId = useMemo(() => `${props.blockIdPrefix}${props.folder.Id}`, [props.folder.Id]);
    const deleteConfrimationRef = useRef(null);
    const handleSaveFolder = useCallback((files) => {
        props.onSaveFolder(props.folder, files);
    }, [props.folder]);
    const getHandleFileClick = useCallback((fileId) => (e) => {
        if (!e.target.closest(".dx-prevent-propagation-click")) {
            props.onSelectFile &&
                props.folder.DocumentId &&
                props.onSelectFile(props.folder.Id, props.folder.DocumentId, fileId);
        }
    }, [props.folder, props.onSelectFile]);
    const getHandleConfirm = useCallback((file) => () => props.onDeleteFile &&
        file.FolderId &&
        props.folder &&
        props.onDeleteFile(file.FolderId, file.Id, props.folder.DocumentId), [props.onDeleteFile, props.folder]);
    const getHandleDownLoad = useCallback((file) => (e) => {
        var _a;
        (_a = e.event) === null || _a === void 0 ? void 0 : _a.stopPropagation();
        props.onDownloadFile && props.onDownloadFile(file.Id);
    }, [props.onDownloadFile]);
    const handleContextMenu = useCallback(buildOnContextMenuCallback(props.documentId, props.documentObjects, undefined, contextMenuRef, imageComponentRef, props.onPhotoSendToGraph, props.onTextSendToGraph), [props.documentId, props.documentObjects, props.onPhotoSendToGraph, props.onTextSendToGraph]);
    const selectedFile = useMemo(() => props.files && props.files[props.selectedFileId], [props.files, props.selectedFileId]);
    const fileUrl = useMemo(() => selectedFile && props.onBuildFileUrl && props.onBuildFileUrl(selectedFile), [selectedFile, props.onBuildFileUrl]);
    const preview = useMemo(() => {
        if (!selectedFile) {
            return (React.createElement(WelcomePanel, { className: "w-100 bg-light-surface-container-low border-rounded-4", messageClassName: "font-base text-light-on-surface-variant", showIcon: false, message: locale.SELECT_FILE }));
        }
        if (selectedFile.FileExtension === fileType.IMAGE) {
            return (React.createElement("img", { className: "w-100-max h-100 img-contain", style: previewImageStyle, src: fileUrl, ref: imageComponentRef }));
        }
        if (selectedFile.FileName.match(/\.mp4$|\.avi$|\.mp3$/) && fileUrl) {
            const ComponentVideo = documentContentTypeToComponent[DOCUMENT_CONTENT_TYPE.VIDEO];
            return React.createElement(ComponentVideo, { value: fileUrl, className: "w-100" });
        }
        if (selectedFile.FileName.match(/\.mp3$|\.ogg$/) && fileUrl) {
            const ComponentAudio = documentContentTypeToComponent[DOCUMENT_CONTENT_TYPE.AUDIO];
            return React.createElement(ComponentAudio, { value: fileUrl, className: "w-100" });
        }
        return (React.createElement(WelcomePanel, { className: "w-100 border-gray-100", messageClassName: "font-base", showIcon: false },
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "text-light-on-surface-variant" },
                    locale.UNKNOWN_FILE,
                    " ",
                    React.createElement("span", { className: "font-bold" }, selectedFile.FileName)),
                React.createElement(Button, { className: "btn-h-m p-8-24", onClick: getHandleDownLoad(selectedFile) },
                    React.createElement("i", { className: "icon-import-file mr-1 font-size-small line-height-medium" }),
                    locale.DOWNLOAD))));
    }, [selectedFile, fileUrl]);
    const renderFiles = useMemo(() => reject(props.files, "Deleted"), [props.files]);
    const leftColStyle = useMemo(() => selectedFile
        ? { height: `calc(100vh - ${props.bottomOffset}px - ${bottomPad}` }
        : { height: "calc(100% - 172px" }, [props.bottomOffset, selectedFile]);
    const openDeleteConfirmation = () => {
        var _a;
        (_a = deleteConfrimationRef.current) === null || _a === void 0 ? void 0 : _a.instance.show();
    };
    return (React.createElement(ProgressOverlay, { show: props.inProgress },
        React.createElement("div", { className: "grid-rows-auto-1fr border-rounded-base border-gray-100 overflow-hidden", onContextMenu: handleContextMenu, style: folderStyle, id: folderBlockId },
            React.createElement("div", { className: "w-100 bg-light-surface-container line-height-small position relative flex-box-centered-content h-left-content with-gap-4", style: folderHeaderStyle },
                React.createElement("i", { className: "icon-minus" }),
                props.folder.Name),
            React.createElement("div", { className: "p-sm bg-white overflow-hidden", style: { height: "calc(100% - 84px)" } }, renderFiles && keys(renderFiles).length ? (React.createElement("div", { className: "d-grid", style: outerGridStyle },
                React.createElement("div", { className: "flex-single-row w-100 v-baseline-items", style: leftColStyle }, preview),
                React.createElement("div", { className: "overflow-hidden pl-1 d-grid", style: innerGridStyle },
                    React.createElement(UploadArea, { handleSaveFolder: handleSaveFolder }),
                    React.createElement(Scrollbars, { className: "mt-1" },
                        React.createElement("div", { className: "d-grid" }, map(renderFiles, file => (React.createElement("div", { onClick: getHandleFileClick(file.Id), className: classNames("flex-single-row clickable mt-0_25 mb-0_25", props.selectedFileId === file.Id &&
                                "bg-light-primary-opacity-7 border-rounded-4"), key: file.Id },
                            React.createElement("img", { className: "mr-xxs ml-xxs", style: thumbStyle, src: fileTypeToIconMap[file.FileExtension || 1], alt: "" }),
                            React.createElement("div", { className: "text-overflow-ellipsis", style: fileNameStyle }, file.FileName),
                            React.createElement("div", { className: "dx-prevent-propagation-click", style: btnHolderStyle },
                                React.createElement(YesNoConfirmation, { onConfirm: getHandleConfirm(file), title: locale.CONFIRMDELETETEXT, headerTitle: locale.DELETE_FILE, popoverRef: deleteConfrimationRef, width: 400, hideOnOutsideClick: true }),
                                React.createElement(Button, { onClick: openDeleteConfirmation, className: "no-border no-default-colors pt-0 pb-0" },
                                    React.createElement("i", { className: "icon-trash font-h4 text-red" })),
                                React.createElement(Button, { className: "no-border no-default-colors pt-0 pb-0 mr-xxs", onClick: getHandleDownLoad(file) },
                                    React.createElement("i", { className: "icon-import-file font-h4 text-light-on-surface-variant" }))))))))))) : (props.files && React.createElement(UploadArea, { handleSaveFolder: handleSaveFolder }))),
            React.createElement(Menu, { mode: "contextmenu", zIndex: parseInt(themeVariables["zindex-pageheader-menu"]) + 1, menuRef: contextMenuRef }))));
}
